import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './SuccessPage.css';
import api from '../../services/publicApi';

const SuccessPage = () => {
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get('order_id');
    const token = searchParams.get('token');
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        let cancelled = false;
        let timer;
        const poll = async (attempt = 0) => {
            if (!orderId || !token) {
                if (!cancelled) setStatus('error');
                return;
            }
            try {
                const data = await api.purchases.getPublic(orderId, token);
                if (cancelled) return;
                if (data.status_code === 'paid') {
                    setStatus('paid');
                } else if (attempt < 14) {
                    setStatus('loading');
                    timer = window.setTimeout(() => poll(attempt + 1), 2000);
                } else {
                    setStatus('pending');
                }
            } catch {
                if (!cancelled) setStatus('error');
            }
        };
        poll();
        return () => {
            cancelled = true;
            if (timer) window.clearTimeout(timer);
        };
    }, [orderId, token]);

    if (status === 'loading') {
        return (
            <div className="success-page">
                <div className="success-container">
                    <p>Проверка платежа...</p>
                </div>
            </div>
        );
    }

    if (status === 'error') {
        return (
            <div className="success-page">
                <div className="success-container">
                    <div className="success-icon">❌</div>
                    <h1>Ошибка</h1>
                    <p className="success-text">Не удалось проверить статус заказа.</p>
                    <a href="/" className="btn btn-primary success-btn">На главную</a>
                </div>
            </div>
        );
    }

    if (status === 'pending') {
        return (
            <div className="success-page">
                <div className="success-container">
                    <div className="success-icon">⏳</div>
                    <h1>Оплата не завершена</h1>
                    <p className="success-text">Платёж ещё не поступил. Попробуйте позже.</p>
                    <a href="/" className="btn btn-primary success-btn">На главную</a>
                </div>
            </div>
        );
    }

    return (
        <div className="success-page">
            <div className="success-container">
                <div className="success-icon">✅</div>
                <h1>Оплата прошла успешно!</h1>
                {orderId && <p className="success-order">Заказ <strong>№{orderId}</strong></p>}
                <p className="success-text">Менеджер свяжется с вами и передаст трек-номер.</p>
                <a href="/" className="btn btn-primary success-btn">На главную</a>
            </div>
        </div>
    );
};

export default SuccessPage;
